
GP.GPMod('Chat.Events', function(self) {
    var _conf, _data, _gui, _apis, _vchat, _util,
        _info, _log, _warn, _error, _timers, _vent, _cometD;

    var _handler_wrap = function (func) {return function () {return func.apply(this, arguments);};};

    this.on('before:start', function() {
        var chat_module = self.app.module("Chat");

        _events.handlers   = _handlers;
        chat_module.events = _events;
    });

    self.init_module = function() {
        var chat_module  = self.app.module("Chat");

        _conf  = chat_module.conf;
        _data  = chat_module.data;
        _apis  = chat_module.apis;
        _gui   = chat_module.gui;
        _util  = chat_module.util;
        _vchat = chat_module.vchat;

        _vent  = self.vent;
        _info  = self.app.Util.info;
        _log   = self.app.Util.log;
        _warn  = self.app.Util.warn;
        _error = self.app.Util.error;
        _trace = self.app.Util.trace;

        _log_obj      = self.app.Util.log_obj;
        _obj_snapshot = self.app.Util.obj_snapshot;
        _handler_wrap = self.app.Util.handler_wrap;

        _cometD = $.cometd;
        _timers = GP.Util.timers;
    };


    var _events = {
        init: function() {
            // setup chat via init_js (triggered either on page load in GP.js, or Page.js:update_page)
            _vent.on('init_js:chat:home', _events.setup);

            _vent.on('cometd:connected', function() {
                _log('cometd connected event received in chat');

                if (_util.chk_chat_vchat(true)) {
                    _events.setup(true);
                    return;
                }

                // if we have something to execute on a successful handshake, then do it (i.e. join a livestream/room)
                if (_data.execute_on_handshake !== false && typeof _data.execute_on_handshake == 'function') {
                    _data.execute_on_handshake.apply(null);
                }
            });

            // cleanup of chat if we aren't on the chat page anymore
            _vent.on('Chat:cleanup VChat:cleanup', _events.cleanup);

            // upload button clicked
            _vent.on('Chat:upload_pic', _events.upload_pic);

            // bind to trigger nanoscroller and scroll to the top
            _vent.on('Nanoscroller:chat:setup', _events.setup_nanoscroll);

            // show room list area for mobile after a backbutton microstate was found/triggered
            _vent.on('Chat:show_mobile_chat_rooms', _gui.show_mobile_chat_rooms);

            // show main chat area for mobile after a backbutton microstate was found/triggered
            _vent.on('Chat:show_mobile_chat_main', _gui.show_mobile_chat_main);

            // show chat user list for mobile after a backbutton microstate was found/triggered
            _vent.on('Chat:show_mobile_chat_users', _gui.show_mobile_chat_users);

            // update this modules internal list of blocked users to hide/ignore
            _vent.on('Chat:update_blocked_users', _events.update_blocked_users);

            // clicking the "Go Live" button to create a videochat room based on user's duid
            // and then join their room as a publisher
            _vent.on('VChat:go_live_nav', _vchat.go_live_nav);
            _vent.on('VChat:go_live', _vchat.go_live);

            // join a video chat room based on user duid as either a publisher or a viewer
            _vent.on('VChat:join_room', _vchat.join_room);

            _vent.on('VChat:deny_private', _vchat.deny_private);
            _vent.on('VChat:confirm_private', _vchat.confirm_private);

            // cancel/abort video chat
            _vent.on('VChat:abort', _vchat.abort);

            // start private/ppm videochat
            _vent.on('VChat:start_ppm', _events.start_ppm);

            // add event handler to update debug flag on the fly via console
            _vent.on('VChat:debug_rtc', function(val) {
                _data.debug_rtc_peer_stats = !!val;
            });

            // listen to this event so we can take action if needed
            // won't need to unless we're redirecting to profile from somewhere else and waiting on that
            _vent.on('init_js:user:profile', _vchat.profile_init);

        },
        setup: function(handshake_success) {
            _vent.trigger('Nanoscroller:chat:setup');

            // setup chat if we're connected to cometd, and navigated to chat/wowza
            // via ajax, or full page load via cometd handshake success event cometd:connected
            if ( (_cometD && _cometD.getStatus() == 'connected') || handshake_success === true) {
                _info('_events.setup logic passed');
                _gui.init();
                _events.init_chat(); // initiate

                // for normal group chat, call this so popstate will be added for mobile
                _gui.show_mobile_chat_rooms();
            } else {
                _warn('setup: NOT connected to cometd');
            }
        },
        // init_chat and setup channel subscriptions
        init_chat: function(wowza_room_id) {
            _info('_events.init_chat called');

            if (_util.is_mobile()) {
                MoshPit.remove_state('jump-page').add_state('jump-page');
            }

            _gui.hide_private_btn();

            // fetch and grab a local copy of our user's that are blocked, so we can filter them out
            GP.reqres.request('User:get_blocked_users', function(blocked_users) {
                if (typeof blocked_users != 'undefined' && blocked_users) {
                    _data.blocked_users = blocked_users;
                }
            });

            // send all these subscribes in a batch instead of separate calls to cometd
            _cometD.batch(function() {
                // channel for admin msgs
                _data.chat_subscriptions[_conf.channel.admin] = _cometD.subscribe(
                    _conf.channel.admin,
                    _handler_wrap(_handlers.on_admin_msg),
                    function(sub_ack) {
                        if (sub_ack.successful) {
                            _log('subscribed to: ', _conf.channel.admin);
                            _data.sub_success.admin = true;
                        }
                    }
                );

                // channel that will provide the rooms available
                _data.chat_subscriptions[_conf.channel.rooms] = _cometD.subscribe(
                    _conf.channel.rooms,
                    _handler_wrap(_handlers.on_room_list),
                    function(sub_ack) {
                        _log('subscribed to: ', _conf.channel.rooms);

                        // publish on the same channel we just successfully subscribed to
                        // so we'll get the list of available rooms from push/cometd
                        // _handlers.on_room_list will be called with the room list
                        if (sub_ack.successful) {
                            _data.sub_success.rooms = true;
                            _log('publishing to: ', _conf.channel.rooms);

                            _cometD.publish(_conf.channel.rooms);
                        }
                    }
                );

                _data.chat_subscriptions[_conf.channel.join_room] = _cometD.subscribe(
                    _conf.channel.join_room,
                    _handler_wrap(_handlers.on_room_joined),
                    function(sub_ack) {
                        if (sub_ack.successful) {
                            _log('subscribed to: ', _conf.channel.join_room);
                            _data.sub_success.join_room = true;

                            // join the user's stream/room if we have a duid/roomId setup
                            // (aka came to see a persons stream/chat)
                            if (wowza_room_id) {
                                _log('found wowza_room_id... calling _events.join_room');
                                _events.join_room(wowza_room_id);
                            }
                        }
                    }
                );

                _data.chat_subscriptions[_conf.channel.leave_room] = _cometD.subscribe(
                    _conf.channel.leave_room,
                    _handler_wrap(_handlers.on_room_left),
                    function(sub_ack) {
                        if (sub_ack.successful) {
                            _log('subscribed to: ', _conf.channel.leave_room);
                            _data.sub_success.leave_room = true;
                        }
                    }
                );

                // channel that will receive broadcasts of updated room counts for public rooms
                _data.chat_subscriptions[_conf.channel.counts] = _cometD.subscribe(
                    _conf.channel.counts,
                    _handler_wrap(_handlers.on_room_user_counts),
                    function(sub_ack) {
                        if (sub_ack.successful) {
                            _log('subscribed to: ', _conf.channel.counts);
                            _data.sub_success.counts = true;
                        }
                    }
                );
            });
        },
        cleanup: function(check_url) {
            // _warn('_events.cleanup called... check_url param: ', check_url, ' _current_module_page: ', _current_module_page);

            if (check_url) {
                if (_util.chk_chat_vchat()) {
                    // call ourself without check_url param
                    _events.cleanup();
                }
            } else {
                _info('calling: ', _conf.channel.leave_room);
                MoshPit.remove_state('mobile-chat-main').remove_state('mobile-chat-users');

                // cleanup hiding growls because of videochat
                _vent.trigger('ActivityPane:hide_growls', false);

                // cleanup video player if applicable
                // _vchat.reset_player();

                if (_cometD && _cometD.getStatus() == 'connected') {
                    _cometD.publish(_conf.channel.leave_room, {
                        room_id: _util.current_room_id()
                    }, function(pub_ack) {
                        if (pub_ack.successful) {
                            _vchat.reset_player();
                            _util.clear_room_timers();
                            _events.clear_subscriptions();
                            _data.reset_chat_data();
                        }
                    });
                } else {
                    _vchat.reset_player();
                    _util.clear_room_timers();
                    _events.clear_subscriptions();
                    _data.reset_chat_data();
                }
            }
        },
        room_clicked: function(e) {
            var room_id = $(this).data('room-id');
            if (_util.current_room_id() == room_id) {
                if (!_util.is_mobile()) {
                    // leave room if we are are not mobile
                    _events.leave_room();
                } else {
                    // if we are on mobile and click the room we are already in, just go back in there
                    _gui.show_mobile_chat_main();
                }
            } else {
                // join room
                _events.join_room(room_id);
            }
        },
        join_room: function(room_id) {
            _log('_events.join_room called: ', room_id);

            // begin with the normal group chat type
            var chat_room_type = 'GROUP';

            // leave room before joining another room
            _events.leave_room(function() {
                if (_data.sub_success.join_room) {
                    _cometD.batch(function() {
                        // Subscribe to the chats of this room
                        _events.subscribe(
                            _conf.channel.messages.replace(_conf.duid_re, room_id),
                            _handler_wrap(_handlers.on_chat_message)
                        );
                        // Subscribe to user's joining/leaving this room
                        _events.subscribe(
                            _conf.channel.users.replace(_conf.duid_re, room_id),
                            _handler_wrap(_handlers.on_users, 'user')
                        );
                        // Subscribe to room specific channel for json messages
                        _events.subscribe(
                            _conf.channel.json.replace(_conf.duid_re, room_id),
                            _handler_wrap(_handlers.on_json_msg)
                        );

                        // change chat_type to _data.vc.type if videochat
                        if (_data.is_videochat) {
                            chat_room_type = _data.vc.type;

                            // change to normal if it's a private videochat and we're not authorized
                            if (_data.vc.private_room && !_data.vc.private_info.private_paid) {
                                chat_room_type = 'NORMAL';
                            }
                        }

                        // publish to the join_room channel to join the chat room
                        _cometD.publish(_conf.channel.join_room, {
                            room_id:   room_id,
                            chat_type: chat_room_type
                        });
                    });
                }
            });
        },
        leave_room: function(func) {
            _log('_events.leave_room called.  _data.current_room: ', _data.current_room);

            var c_room_id = _util.current_room_id();
            if (c_room_id) {
                _info('_events.leave_room FOUND A ROOM TO LEAVE!!!');

                // publish to the leave_room channel if we have a room_id to leave
                _cometD.publish(_conf.channel.leave_room, {
                    room_id: c_room_id
                }, function(pub_ack) {
                    if (pub_ack.successful) {
                        _events.clear_room_subscriptions();

                        if (typeof func === 'function') {
                            func.apply(this, arguments);
                        }
                    }
                });
            } else {
                _events.clear_room_subscriptions();

                if (typeof func === 'function') {
                    func.apply(this, arguments);
                }
            }
        },
        send_chat_message: function() {
            if (_data.free_user) {
                _vent.trigger('Page:billing_redirect');
                return;
            }
            var chat_message = $.trim(_gui.$chat_input.val());

            if (chat_message.substring(0,1) == '/') {
                _gui.clear_chat_input();

                var cmd = '';
                if (chat_message.indexOf(' ') != -1) {
                    cmd = chat_message.substring(1,chat_message.indexOf(' '));
                } else {
                    cmd = chat_message.substring(1, chat_message.length);
                }

                var arg = chat_message.substring(cmd.length+2,chat_message.length);

                if (cmd == 'ban') {
                    if (arg.length) {
                        _apis.add_ban(arg);
                    }
                } else if (cmd == 'unban') {
                    if (arg.length) {
                        _apis.del_ban(arg);
                    }
                }

                return;
            }

            // maybe do some other checking here?
            if (!_data.current_room) {
                _log('send_chat_message had no current_room data.  Rejoin room');
                _util.reset_chat();
                return;
            }

            if (chat_message && _util.current_room_id()) {
                _apis.send_action('send_chat', {
                    'room_id': _util.current_room_id(),
                    text: chat_message
                });
                _gui.clear_chat_input();
            }
        },
        subscribe: function(channel, handler, callback) {
            var subscriptionExists = _data.room_subscriptions.hasOwnProperty(channel);
            if (typeof channel != 'undefined' && typeof handler == 'function' && !subscriptionExists) {
                _log('_events.subscribe called for: ', channel);
                callback = (typeof callback == 'function') ? callback : function(){};

                // wrapping the handler for each channel with _handler_wrap so we can check params in one place
                _data.room_subscriptions[channel] = _cometD.subscribe(
                    channel, _handler_wrap(handler), callback
                );
            }
        },
        // clear only the room specific channels (/chat/users/ID, /chat/messages/ID etc)
        clear_room_subscriptions: function() {
            _info('clear_room_subscriptions called');

            _util.clear_room_timers();
            _data.users.reset();

            if (!$.isEmptyObject(_data.room_subscriptions)) {
                _cometD.batch(function() {
                    _.each(_data.room_subscriptions, function(subscription, channel_string) {
                        try {
                            _log('unsubscribing from: ', channel_string);

                            _cometD.unsubscribe(subscription, function() {
                                delete  _data.room_subscriptions[channel_string];
                            });
                        } catch (e) {
                            _log('caught exception in clear_room_subscriptions: ', e);
                        }
                    });

                    _data.room_subscriptions = {};
                });
            }
        },
        // clear all channel subscriptions associated with chat (room specific and general channels)
        clear_subscriptions: function() {
            _info('clear subscriptions called');

            _cometD.batch(function() {
                if (!$.isEmptyObject(_data.room_subscriptions)) {
                    _.each(_data.room_subscriptions, function(subscription, channel_string) {
                        try {
                            _log('unsubscribing from room channel: ', channel_string);

                            _cometD.unsubscribe(subscription, function() {
                                delete _data.room_subscriptions[channel_string];
                            });
                        } catch (e) {
                            _log('caught exception in clear_subscriptions: ', e);
                        }
                    });
                    _data.room_subscriptions = {};
                }
                if (!$.isEmptyObject(_data.chat_subscriptions)) {
                    _.each(_data.chat_subscriptions, function(subscription, channel_string) {
                        try {
                            _log('unsubscribing from general channel: ', channel_string);

                            _cometD.unsubscribe(subscription, function() {
                                delete _data.chat_subscriptions[channel_string];
                            });
                        } catch (e) {
                            _log('caught exception in clear_subscriptions: ', e);
                        }
                    });
                    _data.chat_subscriptions = {};
                }
            });
        },
        update_current_room_user_count: function() {
            var user_count = _data.users.length;
            var user_count_text = (user_count > 0) ? user_count : 0;
            _gui.update_current_room_user_count(user_count_text);
        },
        upload_pic: function(json) {
            if (_data.free_user) {
                _vent.trigger('Page:billing_redirect');
            } else {
                _vent.trigger('PicUpload:chat_upload', {
                    url:     '/members/chat/upload_pic/',
                    api_url: _conf.api_url,
                    room_id: json.room
                });
            }
        },
        setup_nanoscroll: function() {
            if (!_util.is_mobile()) {
                $('#chat-wrap .js-nano').addClass('nano');
                $('#chat-wrap .js-nano-content').addClass('nano-content');

                $('#chat-wrap .nano').nanoScroller(GP.Util.configs.nanoScroller);
                $('#chat-wrap .nano').nanoScroller({ scroll: 'top' });
                $('#chat-main .nano').nanoScroller({ scroll: 'bottom'});

                $('#chat-main .nano').debounce("update", function(event, values){
                    // if a user scrolls manually, set flag to suppress auto scrolling
                    _data.suppress_scroll = true;
                }, _conf.debounce_miliseconds);
                $('#chat-main .nano').debounce("scrollend", function() {
                    // if a user scrolls all the way down to the bottom, reset flag that suppresses auto scrolling
                    _data.suppress_scroll = false;
                }, _conf.debounce_miliseconds);
            } else {
                _log("mobile size, no nano scroll");
                $(window).debounce('scroll', function(e) {
                    var height = $(window).scrollTop() + $(window).height();
                    var doc_height = GP.Util.get_doc_height();

                    if (height >= (doc_height - _conf.mobile_scroll_height_margin)) {
                        _data.suppress_scroll = false;
                    } else {
                        _data.suppress_scroll = true;
                    }
                }, _conf.debounce_miliseconds);
            }
        },
        setup_nanoscroll_vchat: function() {
            if (!_util.is_mobile()) {
                $('#video-chat-wrap .js-nano').addClass('nano');
                $('#video-chat-wrap .js-nano-content').addClass('nano-content');

                $('#video-chat-wrap .nano').nanoScroller(GP.Util.configs.nanoScroller);
                $('#video-chat-wrap .nano').nanoScroller({ scroll: 'top' });
                $('#video-chat-wrap .nano').nanoScroller({ scroll: 'bottom'});

                $('#video-chat-wrap .nano').debounce("update", function(event, values){
                    // if a user scrolls manually, set flag to suppress auto scrolling
                    _data.suppress_scroll = true;
                }, _conf.debounce_miliseconds);
                $('#video-chat-wrap .nano').debounce("scrollend", function() {
                    // if a user scrolls all the way down to the bottom, reset flag that suppresses auto scrolling
                    _data.suppress_scroll = false;
                }, _conf.debounce_miliseconds);
            } else {
                _log("mobile size, no nano scroll");
                // $(window).debounce('scroll', function(e) {
                //     var height = $(window).scrollTop() + $(window).height();
                //     var doc_height = GP.Util.get_doc_height();

                //     if (height >= (doc_height - _conf.mobile_scroll_height_margin)) {
                //         _data.suppress_scroll = false;
                //     } else {
                //         _data.suppress_scroll = true;
                //     }
                // }, _conf.debounce_miliseconds);
            }
        },
        update_blocked_users: function(blocked_users, new_duid, blocked_by_duid) {
            let my_duid = _data.duid;

            // if the user blocked is current user and the room owner did the blocking/reporting,
            // then reload the page so they can't see the livestream
            let new_duid_chk   = new_duid !== undefined && new_duid !== null;
            let blocked_by_chk = blocked_by_duid !== undefined && blocked_by_duid !== null;

            if (new_duid_chk && blocked_by_chk && my_duid == new_duid) {
                if (_util.current_room_id() == blocked_by_duid) {
                    window.location.reload();
                    return;
                }
            }

            if (typeof blocked_users != 'undefined' && blocked_users && blocked_users.length) {
                _data.blocked_users = blocked_users;
                _data.users.remove(new_duid);
                _events.update_current_room_user_count();

                // hide existing chat history for blocked users and remove from list of user's in room
                _gui.hide_blocked_users_activity();
            }
        },
        show_tip_panel: function(e) {
            var $chat_send_wrap = $('.chat-send-wrap');

            if ($chat_send_wrap.hasClass('show-tip-panel')) {
                _events.hide_tip_panel();
            } else {
                e.stopPropagation();
                $chat_send_wrap.addClass('show-tip-panel');
                $(document).on('click.tip_close', function(e) {
                    if (!$(e.target).closest('.chat-send-wrap').length) {
                        _events.hide_tip_panel();
                    }
                });
            }
        },
        hide_tip_panel: function() {
            $('.chat-send-wrap').removeClass('show-tip-panel');
            $(document).off('click.tip_close');
        },
        send_tip: function(e) {
            var tip_val = $('#vchat-tip-amount').val();
            _apis.send_tip(tip_val, $(this).data('duid'));
        },
        start_ppm: function(json) {
            _log_obj('_events.start_ppm... json: ', json);

            if (_data.duid == json.watcher_duid) {
                _log('START_PPM SWAPPING CURRENT PLAYER/VIEWER to ppm_url... current flussonic urls: ', _conf.flussonic);
                _log('ppm_url: ', json.ppm_url);

                _gui.hide_private_btn();
                $('#stop-private-div').show();

                // set the ppm url in the private_info object prop
                _data.vc.private_info.url = json.ppm_url;
                _data.vc.private_room = true;

                // switch the player's source url and restart stream
                _vchat.switch_player_source(json.ppm_url);

            }
        }
    };


    var _handlers = {
        // callback publish to /service/chat/room_joined when the user joins a chat room
        on_room_joined: function(message) {
            _log('on_room_joined called: ', message);
            var data = message.data;

            // keep track of the room we're in
            _data.current_room = data.room_info;

            var room_id = _util.current_room_id(),
                $roomListDiv = _gui.$rooms_list.find('#room-' + room_id);

            // highlight room in room list if in group chat
            if ($roomListDiv.length) {
                $roomListDiv.addClass('selected');
            }

            // show the main chat area if we're on mobile
            _gui.show_mobile_chat_main();

            _gui.clear_chat_history();

            if (_util.chk_chat_vchat(true)) {
                _gui.focus_chat_input();
            }

            // set the room name and highlight
            _gui.set_room_name(_data.current_room);
            _gui.highlight_room(_data.current_room);

            // store room id with upload button
            $('#chat-message-box button.message-attach-button').data('room', _util.current_room_id());

            if (data.chat_history.chats.length > 0) {
                _gui.add_chat_history(data.chat_history.chats);
            }

            if (data.room_info) {
                _gui.update_rooms_list_user_count(data.room_info.room_id, data.room_info.user_count);
            }

            if (data.users) {
                _info('Setting users for room');
                _data.initial_user_set = true;
                _handlers.set_users_for_room(data.users);
            }

            _util.start_room_timers();

            // flash status message indicating successful room join
            _gui.flash_status('Joined: "' + _data.current_room.name + '"');

            if (_util.is_mobile() && _data.vc.room_id) {
                $('html, body').animate({scrollTop: 0}, 'fast');
            }
        },
        // callback publish to /service/chat/room_left when the user leaves a chat room
        on_room_left: function(message) {
            _log('on_room_left called: ', message);

            var data = (message.data || {}),
                room = data.room_info,
                id   = _util.current_room_id();

            if (room && id && (id == room.room_id)) {
                $('#room-' + room.room_id).removeClass('selected');
                _gui.flash_status('Left: ' + room.name);

                // _gui.clear_users();
                _gui.clear_chat_history();
                _gui.clear_room_name();

                _data.current_room = {};
            }

            if (room) {
                _gui.update_rooms_list_user_count(room.room_id, room.user_count);
            }
        },
        // populate list of available rooms
        on_room_list: function(message) {
            _log('on_room_list called: ', message);

            _data.rooms = message.data;
            _gui.clear_room_list();

            $.each(_data.rooms, function(i, room) {
                if (_util.current_room_id() === room.room_id) {
                    _data.current_room = room;
                    _gui.add_room(room, true);
                } else {
                    _gui.add_room(room, false);
                }

                _gui.update_rooms_list_user_count(room.room_id, room.user_count);
            });
        },
        on_room_user_counts: function(message) {
            // _info('on_room_user_counts called: ', message);

            var rooms = message.data.rooms, room_id, count;

            $.each(rooms, function(i, room) {
                count = room.user_count;
                room_id = room.room_id;

                _gui.update_rooms_list_user_count(room_id, count);
            });
        },
        // chat message received via /chat/ROOM_ID/message
        on_chat_message: function(message) {
            _log('events.on_chat_message called. message: ', message);

            // add chat_info properties to data object (instead of nested in data.chat_info etc)
            if (typeof message != 'undefined' && message.data && message.data.chat_info) {
                var chat_info = message.data.chat_info;

                for (var p in chat_info) {
                    if (chat_info.hasOwnProperty(p) ) {
                        message.data[p] = chat_info[p];
                    }
                }
            }

            _log('events.on_chat_message message before checking json_payload: ', message);

            var json = (message.data.hasOwnProperty('json_payload')) ? self.app.Util.parse_json(message.data.json_payload) : {};

            _log('events.on_chat_message json: ', json);

            if (!$.isEmptyObject(json)) {
            _log('events.on_chat_message json not empty object');

                for (var prop in json) {
                    _log('events.on_chat_message prop: ', prop);
                    if (json.hasOwnProperty(prop) ) {
                        message.data[prop] = json[prop];
                    }
                }
            }
            _log('events.on_chat_message message after checking for json_payload: ', message);

            // check blocked users list and gtfo if user is a blocked user
            if (_util.check_blocked_user(message.data.user.duid)) {
                return;
            }

            // play tip sound effect if chat msg is a tip
            var is_tip_msg = _util.parse_message_for_tip(message.data.text);
            if (is_tip_msg) {
                _vchat.play_loud_tip_sound();
            }

            // if this chat session is a private videochat, and we're the streamer/publisher
            // and the chat msg received is a tip, and isn't from the streamer or the user watching the private show
            if (_data.is_videochat && _data.vc.private_room && _data.vc.is_publisher) {

                var msg_duid     = message.data.user.duid,
                    my_duid      = _data.duid,
                    watcher_duid = _data.vc.private_info.watcher_duid;

                // show a growl instead of putting in the chat history for a tip msg from outside the private chat
                if (msg_duid != my_duid && msg_duid != watcher_duid && is_tip_msg) {
                    var msg_user_model = _data.users.get(msg_duid);
                    if (msg_user_model) {

                        var msg_user = msg_user_model.toJSON(),
                            growl_data = {
                                type: 'generic',
                                duid: msg_duid,
                                pic: msg_user.thumb_url,
                                pg_pic: msg_user.pg_pic,
                                header: 'Tip Received!',
                                text: 'from ' + msg_user.username
                            };

                        // trigger growl and return (no chat msg in chat history window)
                        // _vent.trigger('ActivityPane:add_jgrowl_notification', growl_data);
                        _vent.trigger('ActivityPane:add_activity', growl_data, true);
                    }

                    return;
                }
            }

            // pass message to gui module to handle parsing/displaying of received message
            _gui.add_chat_message(message);

            // only keep X messages visible in history on mobile
            _gui.trim_mobile_history();
        },
        // users joining/leaving a given room via /chat/ROOM_ID/users handled here
        on_users: function(message) {
            _log('on_users called: ', message);
            var json = message.data || {};

            if (!json.user || !json.action) {
                _info('ON_USERS MISSING USER OR ACTION! no action to perform');
                return;
            }

            // call either on_user_joined_room, on_user_left_room or repopulate the user list
            if ('join' === json.action) {
                _handlers.on_user_joined_room(json.user);
            } else if ('leave' === json.action) {
                _handlers.on_user_left_room(json.user);
            }
        },
        // populate complete list of users for a room
        set_users_for_room: function(users) {
            if (typeof users != 'undefined' && users) {
                _log('set_users_for_room called: ', users);
                var tmp_users = [];

                // populate _data.users from supplied user list
                $.each(users, function(i, user) {
                    if (_util.check_blocked_user(user.duid)) {
                        // returning a non boolean false in .each() is like continue; and will continue to the next iteration
                        // returning boolean false is like a break; and will stop iterating over the obj/array
                        return;
                    }
                    tmp_users.push(_util.get_user(user));
                });
                // set our backbone collection to these users
                _data.users.reset(tmp_users);

                _gui.reset_userlist_nanoscroll();
                _gui.update_current_room_user_count(users.length);
            }
        },
        // single user added to list of users for current room
        on_user_joined_room: function(user) {
            if (typeof user != 'undefined' && user && user.duid) {
                if (_util.check_blocked_user(user.duid)) {
                    return;
                }

                var duid = parseInt(user.duid, 10);
                var model_check = _data.users.get(duid);

                if (!model_check) {
                    _info('user not in _data.users, add to members list');
                    _data.users.add(_util.get_user(user),{merge:true});

                    _events.update_current_room_user_count();
                    _util.lazyload();
                } else {
                    _log('user found in _data.users, do not add to members list');
                }
            }
        },
        // single user removed from list of users for current room
        on_user_left_room: function(user) {
            if (typeof user != 'undefined' && user && user.duid) {
                _data.users.remove(parseInt(user.duid, 10));
                _events.update_current_room_user_count();
            }
        },
        tip_error: function(json) {
            var error_message = 'Tip error occured';

            if (json && json.error) {
                error_message = json.error;
            }

            var $error_container = $('.alert-tip-error');
            $error_container.find('p').remove();

            $error_container.append('<p class="error">'+error_message+'</p>');
            $error_container.css('display', 'block');
            setTimeout(function() {
                $error_container.fadeOut();
            }, 5000);
        },
        on_json_msg: function(message) {
            var msg_type = message.data.msg_type;
            var json = {};
            if (message.data.hasOwnProperty('json_payload')) {
                json = self.app.Util.parse_json(message.data.json_payload);
            }

            if ($.isEmptyObject(json) || !json) {
                return;
            }
            _log('!!CHAT ON_JSON_MSG() msg_type: '+msg_type+', json: %o', json);

            var room_id = parseInt(json.room_id, 10) || null;


            // TODO: refactor and clean up this long if/else if/else if logic into separate handler functions


            // videochat state changed, i.e. publish/unpublish to show a spinner or take another action etc
            if (msg_type == 'vc_state_change') {
                if (room_id && _util.current_room_id() === room_id) {
                    _vchat.handle_state_change(json);
                }
            } else if (msg_type == 'vc_private_low_credits') {
                if (_data.duid == json.duid) {
                    // add flag to bypass vjs close on popstate event VChat:abort
                    _data.vc.bypass_vjs_close = true;

                    GP.vent.trigger('Modal:open', {
                        url: "/members/premium/credit_modal/?vc_private=1",
                        spinner: true,
                        bypass_vjs_close: true
                    });
                }
            } else if (msg_type == 'vc_user_banned') {
                if (json.username == GP.sdata.my_user.username) {
                    window.location.reload();
                }
            } else if (msg_type == 'vc_request_private') {
                if (_data.vc.is_publisher === true && !_data.vc.private_room) {
                    _log('vc_request_private', json);
                    _vent.trigger('Modal:open', {
                        keyboard: false,
                        backdrop: 'static',
                        url: '/members/videochat/confirm_private_modal/?username=' + encodeURIComponent(json.username)});
                }
            } else if (msg_type == 'vc_stop_stream') {
                _vchat.abort();

            } else if (msg_type == 'vc_stop_ppm') {
                _log('!!CHAT ON_JSON_MSG() vc_stop_ppm called... _data.vc: ', _data.vc);
                // no need to do all this if not a private videochat session
                if (!_data.vc.private_room) {
                    return;
                }
                _log('!!CHAT ON_JSON_MSG() vc_stop_ppm after private_room logic check');

                // reset videochat _data properties back to normal room/default values
                _vchat.reset_private();


                if (typeof json.notice != 'undefined' && json.notice) {
                    _vent.trigger('Modal:open:alert', {template: json.notice});
                }

                if (_data.vc.is_publisher) {
                    $('#stop-private-div').hide();
                    _gui.show_private_sel();

                    _vchat.switch_publisher_source(_conf.flussonic.source);

                } else {
                    _gui.hide_private_btn();
                    _vchat.switch_player_source(_conf.flussonic.source);
                }

            } else if (msg_type == 'vc_set_private_ppm') {
                _log('vc_set_private_ppm json: ', json);

                // don't show private button if you're a bronze member
                if (GP.sdata.my_user.membership == 'BRONZE') {
                    return;
                }

                // only show the button if you're not the publisher
                if (_data.vc.is_publisher !== true) {
                    if (json.ppm_cost > 0) {
                        _data.vc.ppm_cost = parseInt(json.ppm_cost, 10) || 0;
                        _gui.show_private_btn();
                    } else {
                        _data.vc.ppm_cost = 0;
                        _gui.hide_private_btn();
                    }
                }
            } else if (msg_type == 'vc_confirm_private') {
                _warn('vc_confirm_private... json: ', json);

                _data.vc.private_room = true;
                _data.vc.private_info.watcher_duid = parseInt(json.watcher_duid, 10);

                // publisher/streamer (user putting on the private show)
                if (_data.vc.is_publisher && json.ppm_url) {
                    _log('on_json_msg:vc_confirm_private called');

                    _info('CONFIRM PRIVATE STOPPING CURRENT PUBLISHER with url: ', _data.flussonic.pub_obj.url);
                    _info('NEW PPM_URL FOR PUBLISHER: ', json.ppm_url);

                    // set the ppm url in the private_info object prop
                    _data.vc.private_info.url = json.ppm_url;

                    // switch the player's source url and restart stream
                    _vchat.switch_publisher_source(json.ppm_url);

                }

            } else if (msg_type == 'vc_deny_private') {
                _log('vc_deny_private');

                if (_data.duid == json.duid) {
                    _vent.trigger('Modal:open', {url: '/members/videochat/deny_private_modal/?username=' + encodeURIComponent(_data.vc.username)});
                }
            } else if (msg_type == 'vc_start_ticket') {
                if (_data.vc.is_publisher === true) {
                    _gui.hide_private_sel();
                    _gui.hide_ticket_btn();
                }

                let cost = parseInt(json.credit_cost, 10) || 0;
                if (_data.membership == 'BRONZE' && json.bronze_credit_cost) {
                    cost = parseInt(json.bronze_credit_cost, 10) || 0;
                }

                _data.vc.ticket_info = {
                    info: json.info,
                    credit_cost: cost,
                    start_time: json.start_time
                };
                _gui.init_ticket_info();
            } else if (msg_type == 'vc_cancel_ticket') {
                _log('vc_cancel_ticket event received.... resetting gui');

                _gui.close_ticket_info();
                _util.clear_ticket_show_timers();


                if (!_data.vc.is_publisher && _data.vc.ticket_info.start_time <= 0) {
                    _log('vc_cancel_ticket not publisher and start time <= 0 logic passed... calling video-ticket-notice hide and reset');

                    $("#video-ticket-notice").hide();
                    _vchat.setup_viewer();

                } else if (_data.vc.is_publisher) {
                     _gui.show_private_sel();
                     _gui.show_ticket_btn();
                }
            } else if (msg_type == 'vc_clear_histroy') {
                _log('events.on_json_msg vc_clear_histroy called');
                _log('json: ', json);
                _log('_data.vc: ', _data.vc);

                if (_data.vc.is_publisher === true) {
                    // special msg for publisher here?
                }

                _gui.clear_chat_history();

                // clear history for "chat_type" if that's our current videochat state
                // if (json.chat_type == _data.vc.type) {
                //     _gui.clear_chat_history();
                // }
            } else if (msg_type == 'vc_update_goal_progress') {
                _log('events.on_json_msg vc_update_goal_progress called');

                _vchat.update_goal_progress(json); // was _vchat.tip_received() before
            } else if (msg_type == 'vc_update_tip_goal') {
                _log('events.on_json_msg vc_update_tip_goal called');

                _vchat.update_tip_goal(json);
            } else if (msg_type == 'vc_admin_kill_stream') {
                _vchat.abort();

                if (_data.vc.is_publisher && json.hasOwnProperty('reason')) {
                    $('#publisher-stream-killed').text(json.reason).show();
                }
            } else if (msg_type == 'vc_kick_user') {
                let my_duid   = _data.duid;
                let kick_duid = parseInt(json.kick_duid, 10) || 0;

                if (my_duid === kick_duid) {
                    _vchat.abort();

                    alert('You have been removed by ' + _data.vc.username);
                    window.location.href = GP.Util.clean_url('/members/user/home/');
                }
            }
        },
        on_admin_msg: function(message) {
            var msg_type = message.data.msg_type;
            var json = {};
            if (message.data.hasOwnProperty('json_payload')) {
                json = self.app.Util.parse_json(message.data.json_payload);
            }

            if ($.isEmptyObject(json) || !json) {
                return;
            }
            _log('chat on_admin_msg() msg_type: '+msg_type+', json: %o', json);

            var room_id = parseInt(json.room_id, 10) || null;

            if (msg_type == 'force_leave_videochat') {
                if (room_id && _util.current_room_id() === room_id) {
                    _vchat.abort();
                }
            }
        }
    };

});

